import { Tooltip, type TooltipProps } from "@mui/material";

interface VampTooltipProps {
  title: string;
  placement?: TooltipProps["placement"];
  width?: number;
  children: React.ReactElement;
}

// The mockup's dark tooltip: gray-800 panel, 268px wide, arrow.
export default function VampTooltip({ title, placement = "top", width = 268, children }: VampTooltipProps) {
  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            width,
            maxWidth: width,
            bgcolor: "#1d2939",
            color: "#f2f4f7",
            fontSize: 12,
            lineHeight: "18px",
            fontWeight: 400,
            px: "11px",
            py: "9px",
            borderRadius: "8px",
            boxShadow: "0 10px 24px rgba(16,24,40,0.22)",
          },
        },
        arrow: { sx: { color: "#1d2939" } },
      }}
    >
      {children}
    </Tooltip>
  );
}

interface VampInfoHintProps {
  text: string;
  placement?: TooltipProps["placement"];
  width?: number;
}

export function VampInfoHint({ text, placement = "top", width }: VampInfoHintProps) {
  return (
    <VampTooltip title={text} placement={placement} width={width}>
      <span
        className="inline-flex cursor-help rounded-sm text-gray-400 hover:text-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500"
        tabIndex={0}
        role="button"
        aria-label="More information"
      >
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
      </span>
    </VampTooltip>
  );
}
